import { render, staticRenderFns } from "./categorymail-list.vue?vue&type=template&id=061bf2c7&"
import script from "./categorymail-list.vue?vue&type=script&lang=js&"
export * from "./categorymail-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports